import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAdd,
  faCancel,
  faEdit,
  faSave,
  faSortDown,
  faSortUp,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";
import "./styles.scss";

const Item = ({
  item,
  onItemClick,
  depth,
  updateItemName,
  addCategoriaTemp,
  deleteItem,
  removerTemporario,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState(item.nome);
  const [edit, setEdit] = useState(item.nome === "" ? true : false);
  const [inputError, setInputError] = useState(false);
  const [videoLink, setVideoLink] = useState(item.linkVideoAula); // New state for video link

  const inputRef = useRef(null);
  const itemRef = useRef(null);

  const handleItemClick = () => {
    setIsOpen(!isOpen);
    onItemClick(item.id);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleVideoLinkChange = (e) => {
    setVideoLink(e.target.value);
  };

  const handleAdd = (e) => {
    e && e.stopPropagation();
    addCategoriaTemp(item);
    setIsOpen(true);
  };

  const handleEdit = () => {
    setEdit(!edit);
    inputRef.current.focus();
  };

  const handleDelete = () => {
    deleteItem(item);
  };

  const handleCancelarEdit = (e) => {
    e && e.stopPropagation();
    if (item.nome === "") {
      removerTemporario(item.parentId);
    }

    setInputValue(item.nome);
    setVideoLink(item.linkVideoAula || ""); // Reset video link
    setInputError(false);
    setEdit(false);
  };

  const handleEditSalvar = async (e) => {
    e && e.stopPropagation();
    if (inputValue === item.nome && videoLink === item.linkVideoAula)
      return setEdit(false);

    const result = await updateItemName(item, inputValue, videoLink);
    if (result === null) {
      setInputError(true);
      return;
    }

    setInputError(false);
    setEdit(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (itemRef.current && !itemRef.current.contains(event.target) && edit) {
        handleCancelarEdit();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [edit]);
  return (
    <>
      <div
        ref={itemRef}
        className="category-list-item noSelect"
        onClick={handleItemClick}
        style={{
          paddingLeft: depth * 30 + "px",
          cursor:
            item.children && item.children.length > 0 ? "pointer" : "default",
        }}>
        <div></div>
        <p className="category-list-item-title">{item.tipoNome}</p>
        <div></div>
        <div className="category-list-item-icon-container">
          {item.children && item.children.length > 0 && (
            <FontAwesomeIcon icon={isOpen ? faSortDown : faSortUp} />
          )}
        </div>
        <div className="category-list-input">
          <input
            ref={inputRef}
            readOnly={!edit}
            className={`category-list-item-text ${edit ? "edit" : "no-edit noSelect"
              } ${inputError ? "error" : ""}`}
            style={{
              minWidth: "300px ",
              maxWidth: "500px",
            }}
            value={inputValue}
            onChange={handleInputChange}
          />
          {/* Renderiza o link do vídeo quando não estiver em modo de edição e a categoria for do tipo "conteúdo" */}
          {item.TipoId === 3 && !edit && videoLink && (
            <small className="video-link-preview">
              <a href={videoLink} target="_blank" rel="noopener noreferrer">
                {videoLink.length > 30
                  ? `${videoLink.substring(0, 27)}...`
                  : videoLink}
              </a>
            </small>
          )}
          {/* Renderiza o campo de input para o link do vídeo apenas no modo de edição */}
          {item.tipoNome === "Conteúdo" && edit && (
            <input
              type="text"
              className={`category-list-item-text ${edit ? "edit" : "no-edit noSelect"
                } ${inputError ? "error" : ""}`}
              style={{
                margin: "2rem",
                minWidth: "370px",
                maxWidth: "700px",
              }}
              placeholder="Enter video link..."
              value={videoLink}
              onChange={handleVideoLinkChange}
            />
          )}
          <div className="category-list-btn">
            {!edit ? (
              <>
                <Button
                  className="btn-add"
                  variant="primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAdd();
                  }}>
                  <FontAwesomeIcon icon={faAdd} />
                </Button>
                <Button
                  className="btn-add"
                  variant="primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEdit();
                  }}>
                  <FontAwesomeIcon icon={faEdit} />
                </Button>
                <Button
                  className="btn-add"
                  variant="primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDelete();
                  }}>
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
              </>
            ) : (
              <>
                <Button
                  className="btn-add"
                  variant="primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEditSalvar();
                  }}>
                  <FontAwesomeIcon icon={faSave} />
                </Button>
                <Button
                  className="btn-add"
                  variant="primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCancelarEdit();
                  }}>
                  <FontAwesomeIcon icon={faCancel} />
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
      <div className={`children-container ${isOpen ? "open" : "closed"}`}>
        {isOpen &&
          item.children.map((child) => (
            <Item
              key={child.id}
              item={child}
              onItemClick={onItemClick}
              updateItemName={updateItemName}
              addCategoriaTemp={addCategoriaTemp}
              deleteItem={deleteItem}
              removerTemporario={removerTemporario}
              depth={depth + 1}
            />
          ))}
      </div>
    </>
  );
};
// No changes needed in CategoryList component
const CategoryList = ({
  items,
  updateItemName,
  addCategoriaTemp,
  deleteItem,
  removerTemporario,
  addCategoriaRaizTemp,
  removeCategoriaRaizTemp,
}) => {
  const [openItems, setOpenItems] = useState([]);

  if (!items) return <div>Carregando...</div>;

  const handleItemClick = (itemId) => {
    if (openItems.includes(itemId)) {
      setOpenItems(openItems.filter((id) => id !== itemId));
    } else {
      setOpenItems([...openItems, itemId]);
    }
  };

  return (
    <div className="category-list-container">
      <div className="d-flex  justify-content-start align-items-center">
        <span className="ms-2">Adicione uma nova área do conhecimento</span>
        <Button
          className="btn-categoria-temp ms-3"
          variant="primary"
          onClick={() => addCategoriaRaizTemp(items[0])}>
          <FontAwesomeIcon icon={faAdd} />
        </Button>
        <Button
          className="btn-categoria-temp"
          variant="primary"
          onClick={() => removeCategoriaRaizTemp(items[0])}>
          <FontAwesomeIcon icon={faTrash} />
        </Button>
      </div>
      <hr />
      {items.map((item) => (
        <Item
          key={item.id}
          item={item}
          onItemClick={handleItemClick}
          updateItemName={updateItemName}
          addCategoriaTemp={addCategoriaTemp}
          deleteItem={deleteItem}
          removerTemporario={removerTemporario}
          isOpen={openItems.includes(item.id)}
          depth={0}
        />
      ))}
    </div>
  );
};

export default CategoryList;
